import React from 'react';
import './Methodology.css';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import { Link } from 'react-router-dom';
import Reveal from 'react-reveal/Reveal';


const Methodology = ({ content }) => {
  return (
    <div className="methodology-wrapper">
      <div className="bubble bubble-1 bubble-xl bubble-color-1"></div>
      <div className="bubble bubble-2 bubble-sm bubble-color-4"></div>
      <div className="bubble bubble-3 bubble-sm bubble-color-3"></div>
      <div className="bubble bubble-4 bubble-xl bubble-color-2"></div>
      <section className="methodology container" id="modszertan">
        <Reveal effect="grow-in-bottom">
          <div className="row justify-content-between align-items-center">
            <div className="col-12 col-md-5 col-lg-5">
              <h1>Módszertan</h1>
              <span className="section__description d-block">
                {ReactHtmlParser(content)}
              </span>
              <Link to="/modszertan" className="my-btn mt-4">Bővebben</Link>
            </div>
            <div className="col-12 col-md-7 col-lg-6 d-flex flex-wrap justify-content-center mt-4 mt-md-0">

              <div className="method-item">
                <div className="method-item__title">
                  <i className="fas fa-headphones"></i>
                  <span>Hallgatás</span>
                </div>
                <div className="method-item__children">
                  <div className="method-item__child">Podcast</div>
                  <div className="method-item__child">Film és videó</div>
                </div>
              </div>

              <div className="method-item">
                <div className="method-item__title">
                  <i className="fas fa-bullhorn"></i>
                  <span>Beszéd</span>
                </div>
                <div className="method-item__children">
                  <div className="method-item__child">Szituáció</div>
                  <div className="method-item__child">Társasjáték</div>
                </div>
              </div>

              <div className="method-item">
                <div className="method-item__title">
                  <i className="fas fa-book"></i>
                  <span>Olvasás</span>
                </div>
                <div className="method-item__children">
                  <div className="method-item__child">Könnyített olvasmány</div>
                  <div className="method-item__child">Cikk</div>
                </div>
              </div>

              <div className="method-item">
                <div className="method-item__title">
                  <i className="fas fa-pen-nib"></i>
                  <span>Írás</span>
                </div>
                <div className="method-item__children">
                  <div className="method-item__child">Választott tankönyv</div>
                  <div className="method-item__child">Fogalmazás</div>
                </div>
              </div>

            </div>
          </div>
        </Reveal>
      </section>
    </div>
  );
};


Methodology.propTypes = {
  content: PropTypes.string.isRequired
};

export default Methodology;


// WEBPACK FOOTER //
// ./src/components/Home/Methodology/Methodology.js